// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ul","subtitle":"vl","contentWrap":"wl","imgWrap":"xl","heading":"yl","copy":"zl"};